import {Box, Label, Link} from '@primer/react'

type FeedbackLinkProps = {feedbackUrl: string; title?: string; linkText?: string}

function FeedbackLink({feedbackUrl, title = 'Beta', linkText = 'Feedback'}: FeedbackLinkProps) {
  return (
    <Box sx={{display: 'flex', ml: 2, mt: 4, alignItems: 'center'}}>
      <Label size="small" variant="success">
        {title}
      </Label>
      <Link href={feedbackUrl} sx={{marginLeft: 2}} target="_blank">
        {linkText}
      </Link>
    </Box>
  )
}

export default FeedbackLink

try{ FeedbackLink.displayName ||= 'FeedbackLink' } catch {}